// Import images here. Replace these lines with actual imports from your project.

import tsuiImage from "./assets/images/team/tsui.png";

import hapebgImage from "./assets/images/project/podbg.jpg";
import digibgImage from "./assets/images/project/v2bg.jpg";
import lightcycle1 from "./assets/images/project/lightcyclebgimage.png";

import hapefull from "./assets/images/project/podbg.jpg";
import hapemobile from "./assets/images/project/podbg.jpg";

import lightmobile from "./assets/images/project/mobile/lightmobile.png";
import digimobile from "./assets/images/project/v2bg.jpg";


import digifull from "./assets/images/project/v2bg.jpg";
import mobfull from "./assets/images/project/mobbg.jpg";
import otherproducthape from "./assets/images/project/podbg.jpg";
import otherproductdigi from "./assets/images/project/v2bg.jpg";
import otherproductlight from "./assets/images/project/flawbg.jpg";
import lightfull from "./assets/images/project/flawbg.jpg";



import lightcyclebgImage from "./assets/images/project/flawbg.jpg";

const data = {
art: [
    {
        id: 4,
        linkRoute: "ergfinance",
        protocol: "Mortgage Broking Website",
        desc: "Tailored mortgage broking solutions from experienced brokers across Australia.",
        imageMobile: mobfull,
        name: "ERG Finance",
        image: mobfull,
        otherProductImage: mobfull,
        imagefull: mobfull,
        linkToWeb: "https://www.ergfinance.com.au/",
        singleProduct: [
            {
                linkToWeb: "https://www.ergfinance.com.au/",
                title: "ERG Finance",
                desc: "At ERG Finance, we believe in personalized financial solutions that align with your goals.",
                type1: "WEBSITE",
                type2: "FINANCE",
                type3: "MORTGAGE BROKING",
                productDesc:
                    "Our expert team of mortgage specialists is dedicated to securing the most competitive rates and terms, guiding you through every step of your property investment journey.",
                productPara:
                    "At ERG Finance, we believe in personalized financial solutions that align with your goals. Our expert team of mortgage specialists is dedicated to securing the most competitive rates and terms, guiding you through every step of your property investment journey. Proudly serving clients across the entirety of Australia, we're here to help you succeed no matter where you're located. Established in 2025, we bring fresh perspective combined with deep industry expertise to deliver exceptional mortgage broking services.",
                stats: [
                    {
                        statName1: "Loans Approved",
                        statName2: "Client Satisfaction",
                        statName3: "Years Experience",
                        stat1: "500",
                        stat1Suffix: "+",
                        stat2: "98",
                        stat2Suffix: "%",
                        stat3: "10",
                        stat3Suffix: "+",
                    },
                ],
            },
        ],
    },
    {
        id: 2,
        linkRoute: "pigeon",
        protocol: "AI Productivity Assistant",
        desc: "The next generation AI Messenger combining productivity, automation, and collaboration.",
        imageMobile: hapemobile,
        name: "Pigeon",
        image: hapebgImage,
        otherProductImage: otherproducthape,
        imagefull: hapefull,
        linkToWeb: "https://pigeonlanding-z45t.vercel.app/",
        singleProduct: [
            {
                linkToWeb: "https://pigeonlanding-z45t.vercel.app/",
                title: "Pigeon",
                desc: "One seamless service suite. Stay Caught up. Everywhere.",
                type1: "PRODUCT",
                type2: "AI MESSENGER",
                type3: "PRODUCTIVITY TOOL",
                productDesc:
                    "The superhuman productivity assistant for Telegram and Discord—combining AI-powered task automation, smart collaboration tools, and seamless integrations.",
                productPara:
                    "Pigeon is the next generation AI Messenger that gives you an edge over the traditional way of using Telegram and Discord. It combines AI-powered task automation, smart collaboration tools, and seamless integrations into one platform, transforming how teams communicate and work together. Experience enhanced productivity with intelligent features designed for modern workflows.",
                stats: [
                    {
                        statName1: "Active Users",
                        statName2: "Tasks Automated",
                        statName3: "Time Saved",
                        stat1: "50",
                        stat1Suffix: "K",
                        stat2: "1",
                        stat2Suffix: "M",
                        stat3: "10",
                        stat3Suffix: "K hrs",
                    },
                ],
            },
        ],
    },
    {
        id: 3,
        desc: "An immersive portfolio website.",
        protocol: "Service Portfolio Website",
        linkRoute: "flawlex",
        name: "Flawlex",
        imageMobile: lightmobile,
        image: lightcyclebgImage,
        otherProductImage: otherproductlight,
        imagefull: lightfull,
        linkToWeb: "https://www.flawlex.co",
        singleProduct: [
            {
                linkToWeb: "https://www.flawlex.co",
                title: "Flawlex",
                desc: "A Web3 & Web2 servies website that aims to create the most authentic and immersive apps and websites ever.",
                type1: "WEBSITE",
                type2: "PORTFOLIO",
                type3: "SERVICES",
                productDesc: "Perfection is an illusion. We craft what works.",
                productPara:
                    "At our Creative Studio, we transform concepts into powerful visual stories. Whether you need branding, or high-end content production. With 18 years of expertise in building experiences. We craft products that are shaped by meaningful transactions - of ideas, interactions, and experiences.",

                stats: [
                    {
                        statName1: "Happy Clients",
                        statName2: "Projects Completed",
                        statName3: "Team Members",
                        stat1: "15",
                        stat1Suffix: "+",
                        stat2: "40",
                        stat2Suffix: "+",
                        stat3: "15",
                        stat3Suffix: "",
                    },
                ],
                productImages: [
                    {
                        image: lightcycle1,
                    },
                ],
            },
        ],
    },

        {
        id: 1,
        protocol: "Web3.0 SocialFi Platform",
        desc: "First Innings V2 is a socialfi platform for users to earn points and gain a spot in the most awaited $Sixr.",
        linkRoute: "firstinnings",
        name: "First Innings V2",
        imageMobile: digimobile,
        otherProductImage: otherproductdigi,
        otherProductImageMobile: "",
        image: digibgImage,
        linkToWeb: "https://firstinnings.sixrcricket.com",
        imagefull: digifull,

        singleProduct: [
            {
                title: "First Innings V2",
                linkToWeb: "https://firstinnings.sixrcricket.com",
                desc: "Exclusive Digital Collectibles featuring top cricket icons will boost your points.",
                type1: "PRODUCT",
                type2: "SIXR REWARDS",
                type3: "SOCIALFI PLATFORM",
                productDesc:
                    "Complete social tasks, refer friends, and stack runs.",
                productPara:
                    "SIXR First Innings V2 is the upgraded engagement layer of the SIXR ecosystem — combining Social Engagements, Digital Collectibles, and Web3 incentives into one reward-driven experience.It's designed to reward users with $SIXR tokens for completing social and community-based actions while giving The Legends Collection holders additional in-platform advantages.",
            },
        ],
    },
],
    navLinks: [
        { id: 1, name: "MISSION", linkTo: "secondpage" },
        { id: 2, name: "PROJECTS", linkTo: "projects" },
        // { id: 3, name: "TEAM", linkTo: "team" },
        // { id: 4, name: "PARTNERS", linkTo: "partners" },
        { id: 5, name: "CONTACT US", linkTo: "careers" },
  
    ],
    team: [
        {
            name: "Ander Tusi ",
            role: "Founder & CEO",
            twitter: "https://twitter.com/dt_smat",
            image: tsuiImage,
        },
        {
            name: "Jade Lai-Ting Li ",
            role: "Vice CEO & CEO of Lightcycle",
            twitter: "https://twitter.com/dt_smat",
            image: tsuiImage,
        },
        {
            name: "Justin Duffy ",
            role: "Co-founder & CFO",
            twitter: "https://twitter.com/dt_smat",
            image: tsuiImage,
        },
        {
            name: "Gulio Pezzulli",
            role: "Co-founder & Head of Dapp Development",
            twitter: "https://twitter.com/dt_smat",
            image: tsuiImage,
        },
        {
            name: "Matt Sypien ",
            role: "Founder & CEO of Digimental Studio and Hape",
            twitter: "https://twitter.com/dt_smat",
            image: tsuiImage,
        },
        {
            name: "Bobby Chow ",
            role: "Head of Commercial",
            twitter: "https://twitter.com/dt_smat",
            image: tsuiImage,
        },

        {
            name: "David Parrish",
            role: "Co-founder & Head of BD",
            twitter: "https://twitter.com/SSiddarthsai",
            image: tsuiImage,
        }, // Assuming same image as Nymos
        {
            name: "Sara Ezen",
            role: "Head of Marketing",
            twitter: "https://twitter.com/btwiamjuju",

            image: tsuiImage,
        },
        {
            name: "Katie Ng",
            role: "Co-foundr & Head of Operations",

            twitter: "https://twitter.com/FrOsTces3",
            image: tsuiImage,
        },
    ],


    footerAccordion: [
        {
            id: 1,
            question: "Neowave Studio",
            answer: [ "Projects"],
        },

        {
            id: 2,
            question: "CONTACT US",
            answer: ["Email us: ssiddarthsai1999@gmail.com","Phone: 7358191224"  ],
        },

    ],
secondPage: [
    {
        id: 1,
        question: "Portfolio Website",
        answer: "Showcase your work with a stunning, responsive portfolio that highlights your projects, skills, and achievements professionally",
    },
    {
        id: 2,
        question: "Blog Website",
        answer: "Engaging, SEO-optimized blog platforms with easy content management, perfect for sharing your thoughts and building your audience",
    },
    {
        id: 3,
        question: "E-commerce Website",
        answer: "Full-featured online stores with secure payment integration, inventory management, and seamless shopping experiences",
    },
    {
        id: 4,
        question: "Website for Your Business",
        answer: "Custom business websites that establish your online presence, attract customers, and drive growth with professional design",
    },
    {
        id: 5,
        question: "Discord & Telegram Bots",
        answer: "Advanced bots with custom features, automation, and seamless integrations to enhance community engagement and workflow efficiency",
    },
    {
        id: 6,
        question: "UI/UX Design with Responsive Layout",
        answer: "User-centered design solutions that combine aesthetics with functionality, creating intuitive experiences across all devices and platforms",
    },
],
};

export default data;
